export const tableHeaderCellStyle = () => {
    return {
       /* background: "#EDEDED",*/
        background:'#DAE3F5 !important',
        color: "#242424",
        borderColor: "black",
        height: "20px", // 设置每一行的高度为 50px
    };
};
export const tableCellStyle = () => {
    return {
        // background: "#fafafa",
      /*  color: "#242424",*/
        borderColor: "#333333",
        padding: "0",
        fontSize: "14px",
    };
};
